import { useEffect } from 'react'

/**
 * global-styles.js は html, body に overflow-y: hidden を指定しており、
 * 1024px 以下のメディアクエリでのみ auto になる。
 * SP 向けページを PC 幅で表示してもスクロールできるよう、
 * マウント中だけ inline style で overflow-y: auto を強制する。
 */
export const useEnableBodyScroll = () => {
  useEffect(() => {
    const html = document.documentElement
    const body = document.body
    const prevHtmlOverflowY = html.style.overflowY
    const prevBodyOverflowY = body.style.overflowY

    html.style.overflowY = 'auto'
    body.style.overflowY = 'auto'

    return () => {
      html.style.overflowY = prevHtmlOverflowY
      body.style.overflowY = prevBodyOverflowY
    }
  }, [])
}
